const steps = [
  {
    icon: "ri-book-open-line",
    title: "选择作品",
    desc: "在首页热门作品或题材分类中，找到你感兴趣的一部漫画，点击封面进入阅读。",
  },
  {
    icon: "ri-layout-grid-fill",
    title: "切换阅读模式",
    desc: "在阅读页顶栏一键切换双页模式或滚动阅读，按你的设备与习惯自由选择。",
  },
  {
    icon: "ri-moon-clear-fill",
    title: "开启夜间模式",
    desc: "夜晚追更时点击月亮图标，切换深色护眼底，让眼睛更舒服。",
  },
  {
    icon: "ri-play-list-2-line",
    title: "自动续读",
    desc: "进度自动记忆并保存，下次打开接着看，换设备登录也能同步接续。",
  },
];

export default function Guide() {
  return (
    <section id="guide" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-rocket-line"></i>
            三步上手
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">快速开始阅读</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            没有复杂的操作，从选作品到沉浸阅读，三步就能上手。
          </p>
        </div>

        <div className="relative mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div key={s.title} className="relative rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-background-50">
                {i + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}